import React, {useState, useEffect,useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import PlanCard from "@/pages/admin/Stepper/PlanCard";
import FeatureCard from '@/pages/admin/Stepper/FeatureCard';
import ButtonAdminpanel from '@/components/ButtonAdminpanel';
import { connect } from "react-redux";
import { supplierPlanList } from '@/actions/subscriptionPlanAction';
import { map, wrap, isEqual } from 'lodash';
import axios from 'axios';
import API_URL from '@/constant/api.config';
import { useAuth } from "../../AuthProvider";
import { getSupplierMember } from "@/actions/stepperAction";
import roles from '@/constant/roles.config';
import { hideLoading, showLoading } from "@/actions/loaderAction";
import { buildPath,getPrefix } from '@/utils/common';
import { privateRoutePaths } from '@/routes/private.route.config';


const AdminChoosePlan = (props) => {

  const { id } = useParams();
  const nav = useNavigate();
  const { memberCompanyID, isEndUser, isPreKYCUser, user,setUser } = useAuth();

  const [supplierMember, setSupplierMember] = useState([]);
  
  const [selectedPlan, setSelectedPlan] = useState();

  const [plans, setPlans] = useState([]);

  const [checking, setChecking] = useState(true);


    const [member_supplier_id, setSupplierMemberID] = useState(null);
  

  const getSubscriptionPlans = async () => {
    props.showLoading();
      await props.supplierPlanList().then((response) => {
          if(response.status) {
            setPlans(response.data);
            setSelectedPlan(response.data[1])
          }
      }).catch((err) => {
        console.log("Error ======== ", err);
      });
        props.hideLoading();
  }

  const makePayment = async () => {
    let payReq = {
      member_id: supplierMember?.user_details?.member_id || memberCompanyID,
      email: supplierMember?.user_details?.email || user?.email || "",
      amount: selectedPlan ? selectedPlan.payable_amt : 0,
      plan_name: selectedPlan ? selectedPlan.name : "",
      plan_id: selectedPlan ? selectedPlan.id : 0,
      redirect_to: getPrefix(user),
    }
    console.log("payReq",payReq);

     await axios.post(API_URL + '/stripe/create-payment-link', payReq ).then((response) => {
      if(response.status) {
        const paymentWindow =  window.open(response.data.url, '_blank');

        if (!paymentWindow) {
          alert("Please allow popups for this website.");
          return;
        }

    
      }


    }).catch((err) => {
      console.log("Error =========== ", err);
    })
  }

  const fetchSupplier = async () => {
    try {
      const response = await props.getSupplier(memberCompanyID,"/upgrade_plan");
      setSupplierMember(response.data);
    } catch (err) {
      console.log("Error =", err);
   
    }
  };

  useEffect(() => {
    if (memberCompanyID) {
      setSupplierMemberID(memberCompanyID);
      getSubscriptionPlans();
      fetchSupplier();
    }
  }, [memberCompanyID]);

   

  useEffect(() => {
    const intervalId = setInterval(() => {
      let u = null;
      try {
        u = JSON.parse(localStorage.getItem("user"));
      } catch (e) {
        return; 
      }

      if (!u) return; 

      if (!isEqual(u, supplierMember?.user_details)) {
        if (
          u.role_slug?.slug === "END_USER" &&
          supplierMember?.user_details?.page_type === "upgrade_plan"
        ) {
          window.location.href = `/partner/payment-success`;
        }
      }
    }, 8000);

    return () => clearInterval(intervalId);
  }, [supplierMember]);

  console.log("supplierMember",supplierMember)

  return (
    <div className='upgrade-container container-fluid'>
    <div className='upgrade-layout content-wrap'>
    <div className='choose-plan-wrape'>
         {/* {showLoader && <ScreenLoaderHome />} */}
         <div className='section-header skip-header'>
           <div className="section-content">
            <h2>Choose a Plan That Fits Your Business</h2>
            <p>
              Select a plan designed to help you reach more buyers and unlock more opportunities.
            </p>
            </div>
           
         </div>

          <div className="row g-3">
            {map(plans,(plan,index) => {

              if(plan.name != 'Trial') {
                return (<div className="col-xl-4 py-2" key={plan.id}>
                    <PlanCard
                      title={plan.name}
                      description={plan.description}
                      price={plan.payable_amt}
                      originalPrice={plan.price}
                      image={plan.image}
                      active={selectedPlan?.id === plan.id}
                      onClick={() => setSelectedPlan(plan)}
                    />
                  </div>)
              }
            })}
          </div>

          <div className=''>
          {
            selectedPlan && <FeatureCard planName={selectedPlan.name}  features={selectedPlan.features} />
          }
          </div>
         
         <div className='profile-button border-top'>
           
            
            <ButtonAdminpanel className="mt-3" type="button" onClick={makePayment}>
              Make Payment
            </ButtonAdminpanel>
         </div>
      </div>  
      </div>
      </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    // assignPlan: (member_id) => dispatch(assignSupplierTrailPlan(member_id)),
    supplierPlanList: () => dispatch(supplierPlanList()),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),   
    getSupplier: (member_id,page_type) => dispatch(getSupplierMember(member_id,page_type))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminChoosePlan);